module.exports = __webpack_public_path__ + "static/fonts/PingFang Bold.dd25b35d.ttf";